"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lenderAddressSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.lenderAddressSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['lineOneText', 'municipalityName', 'postalCode', 'provinceCode'],
    properties: {
        lineOneText: {
            type: 'string',
            minLength: 1,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters',
        },
        lineTwoText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 90,
            errorMessage: 'Should be a string with a maximum of 90 characters or null',
        },
        municipalityName: {
            type: 'string',
            minLength: 1,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters',
        },
        postalCode: {
            type: 'string',
            minLength: 6,
            maxLength: 6,
            isValidPostalCode: { $data: '1/provinceCode' },
            errorMessage: 'Should be a valid postal code with 6 characters',
        },
        provinceCode: {
            type: 'string',
            enum: Object.values(constants_1.StatisticsCanadaProvinceID),
            errorMessage: 'Should equate to a valid StatisticsCanadaProvinceID Enum value',
        },
    },
};
